import { RemoteComplementaryLaw, ComplementaryLawSearch } from "../../../../data/usecases/complementary-law/remote-complementary-law";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteComplementaryLaw = (): ComplementaryLawSearch =>
  new RemoteComplementaryLaw("/complementary-law", makeAxiosHttpClient());
